'use strict';

import GenericTableData from './GenericTableData';

// Expense Code Module Event Bus. Handles all interactions with Expense Codes.
let ExpenseCodeData = GenericTableData.getTableDataBus(
  'EXP_CODE',
  'expense_codes',
);

ExpenseCodeData.getECRecordList = (options) => {
  return ExpenseCodeData.getRecordList({
    ...options,
    _sort: [
      ...options._sort,
      ...(options._sort.includes('expense_code') ? [] : ['expense_code']),
    ],
  });
};

ExpenseCodeData.getAllExpenseCodes = () => {
  return ExpenseCodeData.getAllRecords({
    fields: 'expense_code,description',
  });
};

ExpenseCodeData.getABRCodeList = () => {
  return ExpenseCodeData.getAllRecords({
    fields: 'abr_code',
    excludePrimaryKey: true,
    busListenerActionName: 'ABR_LIST_LOADED',
  });
};

export default ExpenseCodeData;
